(function () {
  'use strict';

  console.log('[shop-the-sale] build v3 (aggregated bundle pricing)');

  var section = document.querySelector('.shop-sale');
  if (!section) return;

  var tierRadios = section.querySelectorAll('input[name="sale-tier"]');
  var tierCards = section.querySelectorAll('.shop-sale__tier');
  var addBtn = section.querySelector('[data-add-btn]');
  var btnPrice = section.querySelector('[data-btn-price]');
  var toast = section.querySelector('.shop-sale__toast');

  var _cfgPrices = ((window.__shopTheSaleConfig || {}).prices) || {};
  var PRICES = {
    1: _cfgPrices[1] || 'CAD $59.99',
    2: _cfgPrices[2] || 'CAD $119.98',
    3: _cfgPrices[3] || 'CAD $179.97'
  };
  var TIER_CONFIG = {
    1: { paid: 1, free: 0 },
    2: { paid: 2, free: 1 },
    3: { paid: 3, free: 2 },
  };
  var allProducts = [];
  var currentTier = 2;

  function fetchProducts(page, accumulated) {
    page = page || 1;
    accumulated = accumulated || [];
    var url = '/collections/all/products.json?limit=250&page=' + page;
    return fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.products && data.products.length > 0) {
          accumulated = accumulated.concat(data.products);
          if (data.products.length === 250) {
            return fetchProducts(page + 1, accumulated);
          }
        }
        return accumulated;
      });
  }

  function getInspiredByLabel(product) {
    var tags = Array.isArray(product.tags) ? product.tags : String(product.tags).split(',');
    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i].trim().toLowerCase();
      if (tag.indexOf('inspired_by_') === 0) {
        var raw = tag.substring('inspired_by_'.length);
        var label = raw.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        if (label) return label;
      }
    }
    return product.title;
  }

  function buildCustomOption(title, inspiredBy, hasInspiredBy, index) {
    var item = document.createElement('div');
    item.className = 'mix-custom-select__option';
    item.dataset.value = title;
    item.dataset.index = index;
    var nameEl = document.createElement('div');
    nameEl.className = 'mix-custom-select__option-name';
    nameEl.textContent = title;
    item.appendChild(nameEl);
    if (hasInspiredBy) {
      var subEl = document.createElement('div');
      subEl.className = 'mix-custom-select__option-sub';
      subEl.textContent = 'Inspired by ' + inspiredBy;
      item.appendChild(subEl);
    }
    return item;
  }

  function makeCustomSelectEl() {
    var customEl = document.createElement('div');
    customEl.className = 'mix-custom-select';

    var trigger = document.createElement('div');
    trigger.className = 'mix-custom-select__trigger';
    var triggerText = document.createElement('div');
    triggerText.className = 'mix-custom-select__trigger-text';
    var placeholder = document.createElement('span');
    placeholder.className = 'mix-custom-select__placeholder';
    placeholder.textContent = 'Select a scent...';
    triggerText.appendChild(placeholder);
    var arrowSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrowSvg.setAttribute('class', 'mix-custom-select__arrow');
    arrowSvg.setAttribute('width', '12');
    arrowSvg.setAttribute('height', '8');
    arrowSvg.setAttribute('viewBox', '0 0 12 8');
    var arrowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arrowPath.setAttribute('d', 'M1 1.5l5 5 5-5');
    arrowPath.setAttribute('stroke', 'currentColor');
    arrowPath.setAttribute('stroke-width', '1.5');
    arrowPath.setAttribute('fill', 'none');
    arrowPath.setAttribute('stroke-linecap', 'round');
    arrowSvg.appendChild(arrowPath);
    trigger.appendChild(triggerText);
    trigger.appendChild(arrowSvg);

    var dropdown = document.createElement('div');
    dropdown.className = 'mix-custom-select__dropdown';
    var searchWrap = document.createElement('div');
    searchWrap.className = 'mix-custom-select__search';
    var searchInput = document.createElement('input');
    searchInput.className = 'mix-custom-select__search-input';
    searchInput.type = 'text';
    searchInput.placeholder = 'Search scents...';
    searchInput.setAttribute('autocomplete', 'off');
    searchWrap.appendChild(searchInput);
    dropdown.appendChild(searchWrap);

    allProducts.forEach(function (product, idx) {
      var inspiredBy = getInspiredByLabel(product);
      var hasInspiredBy = inspiredBy !== product.title;
      var item = buildCustomOption(product.title, inspiredBy, hasInspiredBy, idx);
      item.dataset.variantId = product.variants[0].id;
      dropdown.appendChild(item);
    });

    customEl.appendChild(trigger);
    customEl.appendChild(dropdown);
    return customEl;
  }

  function setupCustomSelect(customEl, hiddenSelect) {
    var trigger = customEl.querySelector('.mix-custom-select__trigger');
    var dropdown = customEl.querySelector('.mix-custom-select__dropdown');
    var triggerText = customEl.querySelector('.mix-custom-select__trigger-text');
    var searchInput = customEl.querySelector('.mix-custom-select__search-input');

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = customEl.classList.contains('open');
      section.querySelectorAll('.mix-custom-select.open').forEach(function (el) {
        el.classList.remove('open');
      });
      if (!isOpen) {
        customEl.classList.add('open');
        setTimeout(function () { searchInput.focus(); }, 50);
      }
    });

    dropdown.addEventListener('click', function (e) {
      e.stopPropagation();
      var option = e.target.closest('.mix-custom-select__option');
      if (!option) return;
      var value = option.dataset.value;
      hiddenSelect.value = value;
      dropdown.querySelectorAll('.mix-custom-select__option').forEach(function (el) {
        el.classList.remove('selected');
      });
      option.classList.add('selected');
      var name = option.querySelector('.mix-custom-select__option-name').textContent;
      var subEl = option.querySelector('.mix-custom-select__option-sub');
      triggerText.innerHTML = '';
      var nameDisplay = document.createElement('div');
      nameDisplay.className = 'mix-custom-select__selected-name';
      nameDisplay.textContent = name;
      triggerText.appendChild(nameDisplay);
      if (subEl) {
        var subDisplay = document.createElement('div');
        subDisplay.className = 'mix-custom-select__selected-sub';
        subDisplay.textContent = subEl.textContent;
        triggerText.appendChild(subDisplay);
      }
      searchInput.value = '';
      dropdown.querySelectorAll('.mix-custom-select__option').forEach(function (opt) {
        opt.style.display = '';
      });
      customEl.classList.remove('open');
      hiddenSelect.dispatchEvent(new Event('change'));
    });

    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim().toLowerCase();
      dropdown.querySelectorAll('.mix-custom-select__option').forEach(function (opt) {
        var name = opt.querySelector('.mix-custom-select__option-name').textContent.toLowerCase();
        var sub = opt.querySelector('.mix-custom-select__option-sub');
        var subText = sub ? sub.textContent.toLowerCase() : '';
        opt.style.display = (query === '' || name.indexOf(query) !== -1 || subText.indexOf(query) !== -1) ? '' : 'none';
      });
    });
  }

  function makeSelect(index, type) {
    var select = document.createElement('select');
    select.className = 'shop-sale__scent-select';
    select.dataset.scentIndex = index;
    select.dataset.scentType = type;
    select.style.display = 'none';

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select scent...';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);

    allProducts.forEach(function (product) {
      var opt = document.createElement('option');
      opt.value = product.title;
      opt.textContent = product.title;
      opt.dataset.variantId = product.variants[0].id;
      select.appendChild(opt);
    });

    select.addEventListener('change', checkAllSelected);
    return select;
  }

  function makeRow(index, type) {
    var isFree = type === 'free';
    var row = document.createElement('div');
    row.className = 'shop-sale__scent-row' + (isFree ? ' shop-sale__scent-row--free' : '');

    var num = document.createElement('span');
    num.className = 'shop-sale__scent-num' + (isFree ? ' shop-sale__scent-num--free' : '');
    num.textContent = isFree ? ('Extra #' + (index + 1)) : ('#' + (index + 1));

    var hiddenSelect = makeSelect(index, type);
    var customEl = makeCustomSelectEl();
    setupCustomSelect(customEl, hiddenSelect);

    row.appendChild(num);
    row.appendChild(hiddenSelect);
    row.appendChild(customEl);
    return row;
  }

  function buildDropdowns(container, paidCount, freeCount) {
    container.innerHTML = '';

    var paidHeading = document.createElement('p');
    paidHeading.className = 'shop-sale__scent-section-label';
    paidHeading.textContent = 'Your Scents';
    container.appendChild(paidHeading);

    for (var i = 0; i < paidCount; i++) {
      container.appendChild(makeRow(i, 'paid'));
    }

    if (freeCount > 0) {
      var freeHeading = document.createElement('p');
      freeHeading.className = 'shop-sale__scent-section-label shop-sale__scent-section-label--free';
      freeHeading.textContent = freeCount === 1 ? 'Pick one extra scent' : 'Pick ' + freeCount + ' extra scents';
      container.appendChild(freeHeading);

      for (var j = 0; j < freeCount; j++) {
        container.appendChild(makeRow(j, 'free'));
      }
    }
  }

  function checkAllSelected() {
    var activeContainer = section.querySelector('.shop-sale__tier.active [data-tier-dropdowns]');
    if (!activeContainer) { addBtn.disabled = true; return; }
    var selects = activeContainer.querySelectorAll('.shop-sale__scent-select');
    var allFilled = true;
    selects.forEach(function (sel) { if (!sel.value) allFilled = false; });
    addBtn.disabled = !allFilled;
  }

  function updateTier(tier) {
    currentTier = tier;
    var config = TIER_CONFIG[tier];

    tierCards.forEach(function (card) {
      var t = parseInt(card.dataset.tier, 10);
      var container = card.querySelector('[data-tier-dropdowns]');
      if (t === tier) {
        card.classList.add('active');
        buildDropdowns(container, config.paid, config.free);
      } else {
        card.classList.remove('active');
        container.innerHTML = '';
      }
    });

    btnPrice.textContent = PRICES[tier];
    checkAllSelected();
  }

  function getFirstPaidVariantId() {
    var activeContainer = section.querySelector('.shop-sale__tier.active [data-tier-dropdowns]');
    if (!activeContainer) return null;
    var selects = activeContainer.querySelectorAll('[data-scent-type="paid"]');
    for (var i = 0; i < selects.length; i++) {
      var selectedOpt = selects[i].options[selects[i].selectedIndex];
      if (selectedOpt && selectedOpt.dataset.variantId) {
        return parseInt(selectedOpt.dataset.variantId, 10);
      }
    }
    return null;
  }

  function showToast(message) {
    toast.textContent = message;
    toast.classList.add('visible');
    setTimeout(function () { toast.classList.remove('visible'); }, 3000);
  }

  function refreshCartDrawer(sectionHTML) {
    if (!sectionHTML) return;
    var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (!drawerInner) return;
    var parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
    var newInner = parsed.querySelector('.drawer__inner');
    if (!newInner) return;
    drawerInner.innerHTML = newInner.innerHTML;
    if (!parsed.querySelector('cart-drawer-items.is-empty')) {
      drawerInner.classList.remove('is-empty');
      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.remove('is-empty');
    }
  }

  function updateCartCount(sectionHTML) {
    if (sectionHTML) {
      var parsed = new DOMParser().parseFromString(sectionHTML, 'text/html').querySelector('.shopify-section');
      var current = document.getElementById('cart-icon-bubble');
      if (parsed && current) { current.innerHTML = parsed.innerHTML; return; }
    }
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var cartIcon = document.getElementById('cart-icon-bubble');
        var bubble = document.querySelector('.cart-count-bubble');
        if (cart.item_count > 0) {
          if (!bubble && cartIcon) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
            cartIcon.appendChild(bubble);
          } else if (bubble) {
            var countSpan = bubble.querySelector('span[aria-hidden]');
            if (countSpan) countSpan.textContent = cart.item_count;
            bubble.classList.remove('hidden');
          }
        }
      })
      .catch(function () {});
  }

  function addToCart() {
    var activeContainer = section.querySelector('.shop-sale__tier.active [data-tier-dropdowns]');
    if (!activeContainer) return;

    var config = TIER_CONFIG[currentTier];
    var bundleLabel = currentTier === 1
      ? '1 Bottle'
      : 'Buy ' + config.paid + ' Get ' + config.free + ' Free';

    // Aggregate ALL bottles (paid + free) by variant so every qualifying item
    // is physically in the cart. Shopify's automatic "Signature Scents"
    // discount then applies the free bottles at checkout.
    var order = [];
    var map = {};
    activeContainer.querySelectorAll('[data-scent-type="paid"],[data-scent-type="free"]').forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      var vId = opt && opt.dataset.variantId ? parseInt(opt.dataset.variantId, 10) : null;
      if (!vId) return;
      if (!map[vId]) {
        map[vId] = { id: vId, quantity: 0, title: sel.value };
        order.push(vId);
      }
      map[vId].quantity += 1;
    });

    if (order.length === 0) return;

    var items = order.map(function (vId) {
      var entry = map[vId];
      return { id: entry.id, quantity: entry.quantity, properties: { 'Bundle': bundleLabel, 'Scent': entry.title } };
    });

    addBtn.classList.add('loading');
    addBtn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-icon-bubble,cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function (data) {
        var c = TIER_CONFIG[currentTier];
        var msg = currentTier === 1
          ? '\u2713 Added to cart'
          : '\u2713 Buy ' + c.paid + ' Get ' + c.free + ' Free added to cart';
        showToast(msg);
        addBtn.classList.remove('loading');
        addBtn.innerHTML = 'Add to Cart &mdash; <span data-btn-price>' + PRICES[currentTier] + '</span>';
        btnPrice = section.querySelector('[data-btn-price]');
        updateCartCount(data && data.sections && data.sections['cart-icon-bubble']);
        refreshCartDrawer(data && data.sections && data.sections['cart-drawer']);
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        showToast('Something went wrong. Please try again.');
        addBtn.classList.remove('loading');
        addBtn.innerHTML = 'Add to Cart &mdash; <span data-btn-price>' + PRICES[currentTier] + '</span>';
        btnPrice = section.querySelector('[data-btn-price]');
      });
  }

  document.addEventListener('click', function () {
    section.querySelectorAll('.mix-custom-select.open').forEach(function (el) {
      el.classList.remove('open');
    });
  });

  tierRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      updateTier(parseInt(this.value, 10));
    });
  });

  addBtn.addEventListener('click', function (e) {
    e.preventDefault();
    addToCart();
  });

  fetchProducts()
    .then(function (products) {
      allProducts = products;
      updateTier(2);
    })
    .catch(function (err) {
      console.error('Failed to load products:', err);
    });
})();
